/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Auction } from '../../models/auction';
import { NewAuction } from '../../models/new-auction';

export interface InventoryCreateAuction$Params {
  inventoryId: string;
      body?: NewAuction
}

export function inventoryCreateAuction(http: HttpClient, rootUrl: string, params: InventoryCreateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<Auction>> {
  const rb = new RequestBuilder(rootUrl, inventoryCreateAuction.PATH, 'post');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Auction>;
    })
  );
}

inventoryCreateAuction.PATH = '/inventory/auctions';
